// reducers
import viewReducer from '../components/main/root.reducer'
import MainReducer from '../logic/main/root.reducer'

export default {
  view: viewReducer,
  main: MainReducer,
}
